(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AppraisalFirmRegionSearch', AppraisalFirmRegionSearch);

    AppraisalFirmRegionSearch.$inject = ['$resource'];

    function AppraisalFirmRegionSearch($resource) {
        var resourceUrl =  'api/_search/appraisal-firm-regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
